import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import Footer from "../../../components/Footer/Footer";
import { useIsMobile } from '../../../hooks';
import ReactFullpage from "@fullpage/react-fullpage";
import { Swiper, SwiperSlide } from 'swiper/react';
import WearableProductSection from './WearableProductSection';
import './productsIndex.less';
import 'swiper/css';

function ProductsIndex({ setHeaderDark }) {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false)
  const isMobile = useIsMobile(); // 检测是否是移动设备

  // PC端背景图切换
  const banner = [
    '/images/products/chanpin-banner1.png',
    '/images/products/chanpin-banner2.png',
  ];
  // 移动端背景图
  const bannerMobile = [
    '/images/products/chanpin-banner3.png',
    '/images/products/chanpin-banner4.png',
  ];
  const [bannerIndex, setBannerIndex] = useState(0);
  const goToPrev = () => {
    setBannerIndex((prev) => (prev === 0 ? banner.length - 1 : prev - 1));
    animation()
  };
  const goToNext = () => {
    setBannerIndex((prev) => (prev === banner.length - 1 ? 0 : prev + 1));
    animation()
  };
  const animation = () => {
    const cover = document.querySelector('.Products_cover');
    const title = document.querySelector('.Products_cover-titleText');
    // 重置动画
    cover.style.animation = 'none';
    title.style.animation = 'none';
    // 重新应用动画
    setTimeout(() => {
      cover.style.animation = 'zoomInAndFocus 1.5s ease-out forwards'
      title.style.animation = 'slideUpTitle 1.2s ease-out forwards'
    })
  }

  // 各产品图片、色彩、图片组数据
  const argosPink = [
    '/images/products/argos-pink-img-1.jpg',
    '/images/products/argos-pink-img-2.jpg',
    '/images/products/argos-pink-img-3.jpg',
  ]
  const argosBlue = [
    '/images/products/argos-blue-img-1.jpg',
    '/images/products/argos-blue-img-2.jpg',
    '/images/products/argos-blue-img-3.jpg',
  ]
  const artaList = [
    '/images/products/arta-img-1.jpg',
    '/images/products/arta-img-3.jpg',
    '/images/products/arta-img-2.jpg',
  ]
  const eyepalPick = [
    '/images/products/eyepal-img-1.jpg',
    '/images/products/eyepal-img-2.jpg',
    '/images/products/eyepal-img-3.jpg',
  ]
  const eyepalBlue = [
    '/images/products/eyepal-img-1-color2.png',
    '/images/products/eyepal-img-2-color2.png',
    '/images/products/eyepal-img-3-color2.png',
  ]
  const eyepalPurple = [
    '/images/products/eyepal-img2-color-1.png',
    '/images/products/eyepal-img3-color-1.png',
    '/images/products/eyepal-img4-color-1.png',
  ]

  // 色彩按钮样式
  const borderStylePick = {
    background: 'linear-gradient(rgba(214, 202, 203, 1), rgba(214, 202, 203, 1)) padding-box,linear-gradient(to right, #41D9CF, #2A82E4) border-box',
    border: '4px solid transparent'
  }
  const borderStyleBlue = {
    background: 'linear-gradient(rgba(226, 234, 242, 1), rgba(226, 234, 242, 1)) padding-box,linear-gradient(to right, #41D9CF, #2A82E4) border-box',
    border: '4px solid transparent'
  }
  const borderStyleEyepalPick = {
    background: 'linear-gradient(#DED3C1, #DED3C1) padding-box,linear-gradient(to right, #41D9CF, #2A82E4) border-box',
    border: '4px solid transparent'
  }
  const borderStyleEyepalBlue = {
    background: 'linear-gradient(#585C85, #585C85) padding-box,linear-gradient(to right, #41D9CF, #2A82E4) border-box',
    border: '4px solid transparent'
  }
  const borderStyleEyepalPurple = {
    background: 'linear-gradient(#877CA2, #877CA2) padding-box,linear-gradient(to right, #41D9CF, #2A82E4) border-box',
    border: '4px solid transparent'
  }

  // 产品色彩状态等
  const [argosColor, setArgosColor] = useState('pink')
  const [eyepalColor, setEyepalColor] = useState('pink')

  // 在研方案数据
  const TreatmentPlanList = [
    {
      title: '创新青光眼治疗方案',
      desc: '集视医疗正在开发一种青光眼治疗设备，无需手术和药物治疗即可修复青光眼患者的缺损视野。',
      img: '/images/home/qingguanplan.jpg',
      route: '/glaucoma',
    },
    {
      title: '斜视术后康复数字疗法',
      desc: '集视医疗正在开发一种斜视全周期管理方案，涵盖长期的眼动追踪、15度以内的斜视手术...',
      img: '/images/home/numberplan.jpg',
      route: '/strabismus',
    },
  ]

  // 页状态
  const [isArgosPageActive, setIsArgosPageActive] = useState(false);
  const [isArtaPageActive, setIsArtaPageActive] = useState(false);
  const [isEyepalPageActive, setIsEyepalPageActive] = useState(false);
  const [isPlanPageActive, setIsPlanPageActive] = useState(false);

  // ARGOS颜色切换动画
  const [transitionDirection, setTransitionDirection] = useState(''); //动效方向
  const [currentImage, setCurrentImage] = useState('/images/products/argos-pink-img.png'); //argos当前图片
  const [nextImage, setNextImage] = useState(''); //下一个图片
  const [isTransitioning, setIsTransitioning] = useState(false); //防止动画期间的重复点击
  const [displayedImages, setDisplayedImages] = useState(argosPink); //当前显示的图片组
  const [nextImages, setNextImages] = useState([]); //下一个图片组
  const [isSwitching, setIsSwitching] = useState(false); //是否点击颜色切换动画
  const switchImage = (color) => {
    // 如果点击的是当前颜色则不执行
    if (color === argosColor || isTransitioning) return;
    setIsSwitching(true)
    // 设置主大图
    const newImage = color === 'pink'
      ? '/images/products/argos-pink-img.png'
      : '/images/products/argos-blue-img.png';
    setTransitionDirection('right');
    setNextImage(newImage);
    setArgosColor(color);
    setIsTransitioning(true);
    // 设置下一组图片
    const newImages = color === 'pink' ? argosPink : argosBlue;
    setNextImages(newImages);
    setTimeout(() => {
      setTransitionDirection('');
      setDisplayedImages(newImages);
      setNextImages([]);
      setIsTransitioning(false);
    }, 1000); // 这个时间应该与CSS动画时间匹配
    // 短暂延迟后更新主图片
    setTimeout(() => {
      setCurrentImage(newImage);
    }, 500);
    // 等待滑出动作+进入动作完成后
    setTimeout(() => {
      setIsSwitching(false);
    }, 2400);
  };

  // EYEPAL颜色切换动画
  const [currentEyeImage, setCurrentEyeImage] = useState('/images/products/eyepal-img.png'); //当前图片
  const [nextEyeImage, setNextEyeImage] = useState(''); //下一个图片
  const [displayedEyeImages, setDisplayedEyeImages] = useState(eyepalPick); //当前显示的图片组
  const [nextEyeImages, setNextEyeImages] = useState([]); //下一个图片组
  const switchEyeImage = (color) => {
    // 如果点击的是当前颜色则不执行
    if (color === eyepalColor || isTransitioning) return;
    setIsSwitching(true)
    // 设置主大图
    const newImage = color === 'pink'
      ? '/images/products/eyepal-img.png'
      : color === 'blue' ?
        '/images/products/eyepal-img-color-2.png'
        : '/images/products/eyepal-img-color-1.png';
    setTransitionDirection('right');
    setNextEyeImage(newImage);
    setEyepalColor(color);
    setIsTransitioning(true);
    // 设置下一组图片
    const newImages = color === 'pink' ? eyepalPick : color === 'blue' ? eyepalBlue : eyepalPurple;
    setNextEyeImages(newImages);
    setTimeout(() => {
      setTransitionDirection('');
      setDisplayedEyeImages(newImages);
      setNextEyeImages([]);
      setIsTransitioning(false);
    }, 1000);
    setTimeout(() => {
      setCurrentEyeImage(newImage);
    }, 500);
    setTimeout(() => {
      setIsSwitching(false);
    }, 2400);
  };

  const [swiperKeyArgos, setSwiperKeyArgos] = useState(0);
  const [swiperKeyArta, setSwiperKeyArta] = useState(0);
  const [swiperKeyEyepal, setSwiperKeyEyepal] = useState(0);

  // 各产品配置
  const productConfigs = [
    {
      key: 'argos',
      config: {
        name: 'ARGOS 爱格视™',
        subtitle: '全功能3D近视训练仪',
        link: '/argos',
        mainImage: currentImage,
        mainImageWidth: '64%',
        images: displayedImages,
        colorOptions: [
          { color: 'pink', btnClass: 'Argos_bottom-btn', borderStyle: borderStylePick },
          { color: 'blue', btnClass: 'Argos_bottom-btn', borderStyle: borderStyleBlue }
        ]
      },
      isActive: isArgosPageActive,
      transitionDirection,
      isTransitioning,
      isSwitching,
      swiperKey: swiperKeyArgos,
      displayedImages,
      nextImages,
      currentImage,
      nextImage,
      onSwitchColor: switchImage,
      currentColor: argosColor,
      borderStyles: [borderStylePick, borderStyleBlue]
    },
    {
      key: 'arta',
      config: {
        name: 'ARTA 埃尔塔®',
        // subtitle: '全年龄弱视治疗仪',
        subtitle: '视觉功能训练治疗软件',
        link: '/arta',
        mainImage: '/images/products/arta-black-img.png',
        mainImageWidth: '64%',
      },
      isActive: isArtaPageActive,
      transitionDirection,
      isTransitioning,
      isSwitching,
      swiperKey: swiperKeyArta,
      displayedImages: artaList,
      nextImages: [],
      currentImage: '/images/products/arta-black-img.png',
      nextImage: '',
      onSwitchColor: null,
      currentColor: null,
      borderStyles: []
    },
    {
      key: 'eyepal',
      config: {
        name: 'EYEPAL 眼派™',
        subtitle: '可视温润舒眼仪',
        link: '/eyepal',
        mainImage: currentEyeImage,
        mainImageWidth: '64%',
        images: displayedEyeImages,
        colorOptions: [
          { color: 'pink', btnClass: 'Eyepal_bottom-btn', borderStyle: borderStyleEyepalPick },
          { color: 'blue', btnClass: 'Eyepal_bottom-btn', borderStyle: borderStyleEyepalBlue },
          { color: 'purple', btnClass: 'Eyepal_bottom-btn', borderStyle: borderStyleEyepalPurple }
        ]
      },
      isActive: isEyepalPageActive,
      transitionDirection,
      isTransitioning,
      isSwitching,
      swiperKey: swiperKeyEyepal,
      displayedImages: displayedEyeImages,
      nextImages: nextEyeImages,
      currentImage: currentEyeImage,
      nextImage: nextEyeImage,
      onSwitchColor: switchEyeImage,
      currentColor: eyepalColor,
      borderStyles: [borderStyleEyepalPick, borderStyleEyepalBlue, borderStyleEyepalPurple]
    }
  ];

  return (
    <div className="Products">
      <ReactFullpage
        debug={false}
        scrollOverflow={true}
        scrolloverflowmacstyle={false}
        anchors={["coverPage", "argosPage", "artaPage", "eyepalPage", "planPage"]}
        onLeave={(origin, destination) => {
          setIsArgosPageActive(destination.index === 1);
          setIsArtaPageActive(destination.index === 2);
          setIsEyepalPageActive(destination.index === 3);
          setIsPlanPageActive(destination.index === 4);
          if (origin.index === 1) {
            setSwiperKeyArgos(prev => prev + 1);
            setArgosColor('pink')
            setDisplayedImages(argosPink)
            setCurrentImage('/images/products/argos-pink-img.png')
          }
          if (origin.index === 2) {
            setSwiperKeyArta(prev => prev + 1);
          }
          if (origin.index === 3) {
            setSwiperKeyEyepal(prev => prev + 1);
            setEyepalColor('pink')
            setDisplayedEyeImages(eyepalPick)
            setCurrentEyeImage('/images/products/eyepal-img.png')
          }
        }}
        afterLoad={(origin, destination) => {
          if (destination.index !== 0) {
            setHeaderDark(true)
          } else {
            setHeaderDark(false)
          }
        }}
        render={({ state, fullpageApi }) => {
          const handleClick = () => {
            fullpageApi.moveTo('argosPage');
          };
          return (
            <ReactFullpage.Wrapper>
              {/* 标题页 */}
              <div className="section">
                <div
                  className='Products_cover'
                  style={{
                    '--bg-image': `url(${banner[bannerIndex]})`,
                  }}
                >
                  {/* 移动端：使用 Swiper 滑动切换 */}
                  {isMobile && (
                    <Swiper
                      slidesPerView={1}
                      onSlideChange={(swiper) => {
                        setBannerIndex(swiper.activeIndex)
                        animation()
                      }}
                      initialSlide={bannerIndex}
                      className="mobile-swiper"
                    >
                      {bannerMobile.map((img, index) => (
                        <SwiperSlide key={index}>
                          <div
                            className="swiper-slide-bg"
                            style={{ backgroundImage: `url(${img})`, animation: `${index === 0 ? 'zoomInAndFocus 1.5s ease-out forwards' : ''}` }}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  )}
                </div>
                <div className='Products_cover-title pageMargin' style={{ position: 'relative', zIndex: 10 }}>
                  <div className="of_hidden">
                    {/* <div className='Products_cover-titleText'>世界领先的<br />脑科学机制研究驱动的眼科诊疗平台</div> */}
                    <div className='Products_cover-titleText'>脑科学机制研究驱动的眼科诊疗平台</div>
                  </div>
                </div>
                <div className="App_cover-bottom flex_col flex_ai-c" style={{ zIndex: 10 }}>
                  <img
                    className='App_cover-bottomImg cur_p'
                    src='/images/products/downIcon.png'
                    alt=''
                    onClick={handleClick}
                  />
                  <div className='App_cover-bottomSlider'>
                    <div
                      className='sliderBtn'
                      onClick={goToPrev}
                    >
                      <img
                        src='./images/home/whiteLeftIcon.png'
                        alt=''
                      />
                    </div>
                    <div className='flex_row flex_ai-c'>
                      {banner.map((_, index) => (
                        <div
                          key={index}
                          className={`product_indicator ${index === bannerIndex ? 'active' : ''}`}
                        />
                      ))}
                    </div>
                    <div
                      className='sliderBtn'
                      onClick={goToNext}
                    >
                      <img
                        src='./images/home/whiteRightIcon.png'
                        alt=''
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* ARGOS、ARTA、EYEPAL 共用组件调用 */}
              {productConfigs.map(item => (
                <div className="section" key={item.key}>
                  <WearableProductSection
                    isActive={item.isActive}
                    hovered={hovered}
                    setHovered={setHovered}
                    navigate={navigate}
                    config={item.config}
                    transitionDirection={item.transitionDirection}
                    isTransitioning={item.isTransitioning}
                    isSwitching={item.isSwitching}
                    swiperKey={item.swiperKey}
                    displayedImages={item.displayedImages}
                    nextImages={item.nextImages}
                    currentImage={item.currentImage}
                    nextImage={item.nextImage}
                    onSwitchColor={item.onSwitchColor}
                    currentColor={item.currentColor}
                    borderStyles={item.borderStyles}
                  />
                </div>
              ))}

              {/* 集视在研方案 */}
              <div className="section">
                <div className='pageMargin of_hidden'>
                  <div className='Argos_top c_23253B'>
                    <div className='of_hidden'>
                      {/* PC端 */}
                      <div className={`Argos_topBlockPc flex_row flex_jc-sb ${isPlanPageActive ? 'active' : ''}`}>
                        <div className='fz_32 fw_700 lh_38'>集视在研方案</div>
                        <div className='fz_20 fw_500 lh_24'>Focusight®<br />Treatment plan</div>
                        <div className='fz_16 fw_500 lh_24'>集视医疗致力于融合底层脑科学+眼病机制研究+可穿戴智能化产品，<br />突破传统干预手段年龄、效果、地点、依从性等限制。</div>
                      </div>
                      {/* 移动端 */}
                      <div className='Argos_topBlockMobile'>
                        <div className={`Argos_topMobile ${isPlanPageActive ? 'active' : ''}`}>
                          <div className='fz_18 fw_700 lh_21'>集视在研方案</div>
                          <div className='fz_14 fw_500 lh_16 mt_6'>Focusight®<br />Treatment plan</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* PC端 */}
                  <div className={`btn_display Plan_content of_hidden flex_row flex_jc-c flex_ai-c ${isPlanPageActive ? 'active' : ''}`}>
                    <img
                      src='/images/home/numberplan.jpg'
                      alt=''
                    />
                    <div className="Plan_content-bottom" >
                      <div className={`Plan_content-block ${isPlanPageActive ? 'active' : ''}`}>
                        <div className="fz_32 fw_900 lh_38 ellipsis">斜视术后康复数字疗法</div>
                        <div className="fz_16 fw_500 lh_24 mt_6 multiline-ellipsis-2">集视医疗正在开发一种斜视全周期管理方案，涵盖长期的眼动追踪、15度以内的斜视手术...</div>
                        <div
                          className='Plan_bottom-btn flex_center mt_30'
                          onClick={(() => navigate('/strabismus'))}
                        >
                          了解方案
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`Plan_bottom ${isPlanPageActive ? 'active' : ''}`}>
                  <div className='Plan_bottomBlock pageMargin of_hidden'>
                    {TreatmentPlanList.map((item) => <div className={`Plan_bottomItem flex_row flex_ai-c ${isPlanPageActive ? 'active' : ''}`} key={item.title}>
                      <img
                        src={item.img}
                        alt=''
                      />
                      <div
                        className='TreatmentPlan_itemBlock flex_col flex_jc-sb'
                      >
                        <div>
                          <div className="TreatmentPlan_itemTitle ellipsis">{item.title}</div>
                          <div className="TreatmentPlan_itemSubTitle multiline-ellipsis-2">{item.desc}</div>
                        </div>
                        <div
                          className='Plan_bottom-btn flex_center'
                          onClick={(() => navigate(item.route))}
                        >
                          了解方案
                        </div>
                      </div>
                    </div>)}
                  </div>
                </div>
                <Footer />
              </div>
            </ReactFullpage.Wrapper>
          )
        }}
      />
    </div>
  );
}

export default ProductsIndex;